import { get, writable } from "svelte/store";
import { appManager } from "../../../AppManager";
export class ScenarioShareToolBoxManager {
    constructor(parent, toolBoxManager) {
        this.sharedScenariosStore = writable([]);
        this.parent = parent;
        this.toolBoxManager = toolBoxManager;
        this.parent.getScenarioDataStore().subscribe(async () => {
            await this.loadShares();
        });
    }
    getSharedScenariosStore() {
        return this.sharedScenariosStore;
    }
    getOpenToolBoxStore() {
        return this.toolBoxManager.getOpenToolBoxStore();
    }
    async initializeAsync() {
        await this.loadShares();
    }
    async loadShares() {
        const scenario = get(this.parent.getScenarioDataStore());
        if (typeof scenario === "undefined")
            return;
        const accessToken = await appManager.api.getAccessToken();
        const response = await appManager.api.projects.getSharedScenariosForScenario({
            scenarioId: scenario.id,
            accessToken: accessToken,
        });
        this.sharedScenariosStore.set(response.sharedScenarios);
    }
    async createNewShare() {
        const scenario = get(this.parent.getScenarioDataStore());
        const accessToken = await appManager.api.getAccessToken();
        await appManager.api.projects.postSharedScenario({
            scenarioId: scenario.id,
            accessToken: accessToken,
        });
        const response = await appManager.api.projects.getSharedScenariosForScenario({
            scenarioId: scenario.id,
            accessToken: accessToken,
        });
        this.sharedScenariosStore.set(response.sharedScenarios);
    }
    async deleteShare(id) {
        const scenario = get(this.parent.getScenarioDataStore());
        const accessToken = await appManager.api.getAccessToken();
        await appManager.api.projects.deleteSharedScenario({
            id: id,
            accessToken: accessToken,
        });
        const response = await appManager.api.projects.getSharedScenariosForScenario({
            scenarioId: scenario.id,
            accessToken: accessToken,
        });
        this.sharedScenariosStore.set(response.sharedScenarios);
    }
}
